(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.FieldprintService = (function(superClass) {
    extend(FieldprintService, superClass);

    function FieldprintService(http, state, rootScope) {
      this.http = http;
      this.state = state;
      this.rootScope = rootScope;
      this.goToFirstIncompleteStep = bind(this.goToFirstIncompleteStep, this);
      this.downloadPdfs = bind(this.downloadPdfs, this);
      this.resetDrawdown = bind(this.resetDrawdown, this);
      this.resetDropDown = bind(this.resetDropDown, this);
      this.hasPBIUploadedConnection = bind(this.hasPBIUploadedConnection, this);
      this.getManagementTechniquesDefaults = bind(this.getManagementTechniquesDefaults, this);
      this.hasCoverCropEvents = bind(this.hasCoverCropEvents, this);
      this.badGeometry = bind(this.badGeometry, this);
      this.badMyFarms = bind(this.badMyFarms, this);
      this.badPlantableAcres = bind(this.badPlantableAcres, this);
      this.badClimate = bind(this.badClimate, this);
      this.badSoils = bind(this.badSoils, this);
      this.calculatorErrored = bind(this.calculatorErrored, this);
      this.calculatorPending = bind(this.calculatorPending, this);
      this.calculatorFailed = bind(this.calculatorFailed, this);
      this.calculatorSucceeded = bind(this.calculatorSucceeded, this);
      this.irrigationValidationValues = bind(this.irrigationValidationValues, this);
      this.calculateCompleteness = bind(this.calculateCompleteness, this);
      this.updateCompletenessFor = bind(this.updateCompletenessFor, this);
      this.save = bind(this.save, this);
      this.copy = bind(this.copy, this);
      this.findStepIndexByName = bind(this.findStepIndexByName, this);
      this.gotoStep = bind(this.gotoStep, this);
      this.triggerMissing = bind(this.triggerMissing, this);
      this.loadFieldprint = bind(this.loadFieldprint, this);
      this.createFieldprint = bind(this.createFieldprint, this);
      this.loadFieldBoundary = bind(this.loadFieldBoundary, this);
      this.getPBIConnection = bind(this.getPBIConnection, this);
      this.getFieldLinkedUploadedPbi = bind(this.getFieldLinkedUploadedPbi, this);
      this.getFieldLinkedExternally = bind(this.getFieldLinkedExternally, this);
      this.getBoundaryImage = bind(this.getBoundaryImage, this);
      this.getPreviousFieldprintCropYield = bind(this.getPreviousFieldprintCropYield, this);
      this.getAllCrops = bind(this.getAllCrops, this);
      this.getCrops = bind(this.getCrops, this);
      this.getYears = bind(this.getYears, this);
      this.getDefaults = bind(this.getDefaults, this);
      this.checkOtherPractices = bind(this.checkOtherPractices, this);
      this.loadConfig = bind(this.loadConfig, this);
      this.onDataLoaded = bind(this.onDataLoaded, this);
      this.reset = bind(this.reset, this);
      this.reset();
      this.config = {};
      this.phosphorousDisabledHoverMessage = 'These inputs do not apply because you did not add phosphorous to the Fertilizer form on Step 1.';
      this.phosphorousDrawdownDisabledHoverMessage = 'These options are not available unless the "Excessive/Very High" option is selected for the phosphorous soil test level input.';
      this.year = moment().format('YYYY');
      this.crop = null;
      this.mfCrop = null;
      this.field = null;
      this.onSaveTriggers = [];
      this.rootScope.fpcTriggerMissing = 0;
      this.phosphorousAndNitrogenUsage = null;
      this.loadConfig();
      this.http.get('backend/grower/fieldprint/validation-values').then((function(_this) {
        return function(response) {
          _this.validationCropValues = response.data.crop;
          return _this.validationIrrigationValues = response.data.irrigation;
        };
      })(this));
      this.getCrops().then((function(_this) {
        return function(response) {
          return _this.crops = response.data.data;
        };
      })(this));
      Socket.register('reloadIrrigationImage', (function(_this) {
        return function(data) {
          var ref, ref1;
          if (((ref = _this.fpcResult) != null ? (ref1 = ref.field) != null ? ref1.id : void 0 : void 0) === data.fieldId) {
            return typeof _this.getBoundaryImage === "function" ? _this.getBoundaryImage() : void 0;
          }
        };
      })(this));
      this.http.get('backend/user-info/company').then((function(_this) {
        return function(response) {
          return _this.hasSaifsaOtherPractices = response.data.company_configuration.has_saifsa_other_practices;
        };
      })(this));
    }

    FieldprintService.prototype.reset = function() {
      this.id = null;
      this.fpcResult = {};
      this.currentStepIndex = 0;
      this.currentStepName = '';
      this.visitedSteps = [];
      this.savedSteps = [];
      this.brandNew = false;
      this.completenessElements = {};
      this.showIncompletenessMessage = false;
      this.changeStepFromSidebar = false;
      this.hasPBIConnection = false;
      this.isFieldLinkedExternally = false;
      this.isFieldLinkedUploadedPbi = false;
      this.phosphorousAndNitrogenUsage = null;
      this.getCrops().then((function(_this) {
        return function(response) {
          return _this.crops = response.data.data;
        };
      })(this));
      return this.loadConfig();
    };

    FieldprintService.prototype.onDataLoaded = function(scope, callback) {
      var handler;
      handler = this.rootScope.$on('fieldprint-loaded', callback);
      scope.$on('$destroy', handler);
      if (Object.keys(this.fpcResult).length) {
        return callback();
      }
    };

    FieldprintService.prototype.loadConfig = function() {
      return this.http.get('backend/grower/fieldprint/config').then((function(_this) {
        return function(response) {
          return _this.config = response.data;
        };
      })(this));
    };

    FieldprintService.prototype.checkOtherPractices = function() {
      return this.http.post('backend/grower/other-practices/exists', {
        year: this.year,
        crop: this.crop
      }).then((function(_this) {
        return function(response) {
          return _this.hasOtherPractices = parseInt(response.data);
        };
      })(this));
    };

    FieldprintService.prototype.getDefaults = function(config) {
      var defaults, key, ref, value;
      defaults = {};
      for (key in config) {
        value = config[key];
        if (((ref = value.value) != null ? ref["default"] : void 0) != null) {
          if (!Array.isArray(value.value["default"].value) && value.value["default"].value instanceof Object) {
            defaults[key] = Object.keys(value.value["default"].value);
          } else {
            defaults[key] = value.value["default"].value;
          }
        }
        if (value !== null && typeof value === 'object') {
          angular.extend(defaults, this.getDefaults(value));
        }
      }
      return defaults;
    };

    FieldprintService.prototype.getYears = function() {
      return this.http.get('backend/grower/data/ng-get-all-years');
    };

    FieldprintService.prototype.getCrops = function() {
      return this.http.get('backend/grower/fieldprint/crops');
    };

    FieldprintService.prototype.getAllCrops = function() {
      return this.http.get('backend/grower/fieldprint/all-crops');
    };

    FieldprintService.prototype.getPreviousFieldprintCropYield = function() {
      return this.http.get('backend/grower/fieldprint/fieldprint-crop-yield', {
        params: {
          year: this.year - 1,
          field_id: this.field
        }
      }).then((function(_this) {
        return function(response) {
          return _this.previousFieldprintCropYield = response.data;
        };
      })(this));
    };

    FieldprintService.prototype.getBoundaryImage = function() {
      return this.http.post('backend/grower/fieldprint/boundary-image', {
        fpcResultId: this.fpcResult.id
      }).then((function(_this) {
        return function(response) {
          return _this.imagePath = "backend/grower/download/load-image?path=" + response.data + "&cachebust=" + (Math.random());
        };
      })(this));
    };

    FieldprintService.prototype.getFieldLinkedExternally = function() {
      return this.http.get('backend/grower/pbi/field-linked-external/' + this.field, {
        params: {
          year: this.year
        }
      }).then((function(_this) {
        return function(response) {
          return _this.isFieldLinkedExternally = response.data;
        };
      })(this));
    };

    FieldprintService.prototype.getFieldLinkedUploadedPbi = function() {
      return this.http.get('backend/grower/pbi/field-linked-uploaded-pbi/' + this.field, {
        params: {
          year: this.year
        }
      }).then((function(_this) {
        return function(response) {
          return _this.isFieldLinkedUploadedPbi = response.data;
        };
      })(this));
    };

    FieldprintService.prototype.getPBIConnection = function() {
      return this.http.get('backend/grower/pbi/has-connection', {
        params: {
          year: this.year
        }
      }).then((function(_this) {
        return function(response) {
          return _this.hasPBIConnection = response.data.has_connection;
        };
      })(this));
    };

    FieldprintService.prototype.loadFieldBoundary = function(fieldId) {
      if (!App.layer_store.exists(fieldId)) {
        App.layer_store.empty();
        return App.layer_store.loadField(fieldId, {
          fillOpacity: 0.0
        });
      }
    };

    FieldprintService.prototype.createFieldprint = function(year, crop, field) {
      this.year = year;
      this.crop = crop;
      this.field = field;
      this.checkOtherPractices();
      return this.http.post('backend/grower/fieldprint/create', {
        year: year,
        crop: crop,
        field: field
      });
    };

    FieldprintService.prototype.loadFieldprint = function(id) {
      return this.http.get("backend/grower/fieldprint/" + id).then((function(_this) {
        return function(response) {
          var defaults;
          _this.year = response.data.year;
          _this.crop = response.data.ftm_crop.name;
          _this.mfCrop = response.data.crop.name;
          _this.field = response.data.fields_id;
          _this.fpcResult = response.data;
          defaults = _this.getDefaults(_this.config[_this.crop]);
          _this.fpcResult.data = angular.extend({}, defaults, _this.fpcResult.data);
          _this.getBoundaryImage();
          _this.getAllCrops().then(function(response) {
            return _this.allCrops = response.data;
          });
          _this.getPreviousFieldprintCropYield();
          _this.getFieldLinkedExternally();
          _this.getFieldLinkedUploadedPbi();
          _this.getPBIConnection();
          _this.visitedSteps = response.data.visited_steps;
          _this.savedSteps = response.data.saved_steps;
          _this.rootScope.$emit('fieldprint-loaded');
          return _this.checkOtherPractices();
        };
      })(this));
    };

    FieldprintService.prototype.triggerMissing = function(stepNumber) {
      if (stepNumber > this.currentStepIndex) {
        if (this.fpcResult.completeness.steps[this.currentStepName] === false) {
          this.rootScope.fpcTriggerMissing++;
          return true;
        }
      }
      return false;
    };

    FieldprintService.prototype.gotoStep = function(stepNumber, id, saveData, fromSidebar, goingToFirstIncompleteStep) {
      var moveStep;
      if (saveData == null) {
        saveData = true;
      }
      if (fromSidebar == null) {
        fromSidebar = false;
      }
      if (goingToFirstIncompleteStep == null) {
        goingToFirstIncompleteStep = false;
      }
      moveStep = (function(_this) {
        return function() {
          var currentStepName;
          _this.changeStepFromSidebar = fromSidebar;
          if (!id) {
            id = _this.state.params.id;
          }
          if (!id) {
            throw new Error("FPC: Going to step " + stepNumber + " but no fpc result id specified!");
          }
          if (saveData) {
            _this.save(id);
          }
          if (_this.triggerMissing(stepNumber)) {
            _this.showIncompletenessMessage = true;
            return;
          }
          _this.showIncompletenessMessage = false;
          _this.currentStepIndex = stepNumber;
          _this.currentStepName = _.findKey(_this.config[_this.crop].steps.value, function(obj) {
            return obj.order === stepNumber;
          });
          if (_this.currentStepName) {
            currentStepName = _this.currentStepName;
            _this.http.post("backend/grower/fieldprint/" + id + "/step/" + currentStepName + "/visited");
            _this.visitedSteps.push(currentStepName);
          }
          return _this.state.go('grower.fieldprint.step', {
            id: id,
            step: stepNumber + 1
          });
        };
      })(this);
      if (stepNumber === 1) {
        return this.http.get('backend/grower/fieldprint/nitrogen-or-phosphorus', {
          params: {
            year: this.fpcResult.year,
            fieldId: this.fpcResult.field.id,
            crop: this.fpcResult.crop.name
          }
        }).then((function(_this) {
          return function(response) {
            _this.phosphorousAndNitrogenUsage = response.data;
            if (!response.data.phosphorous_applied) {
              _this.fpcResult.data.years_phosphorous_applicable = null;
              _this.fpcResult.data.conducted_soil_test = false;
              _this.fpcResult.data.phosphorous_soil_test_level = null;
            }
            if (response.data.nitrogen_applied === false && response.data.phosphorous_applied === false) {
              if (goingToFirstIncompleteStep) {
                _this.goToFirstIncompleteStep(id, true);
                return;
              }
              if (stepNumber === 1 && _this.currentStepIndex === 0) {
                stepNumber += 1;
              } else if (stepNumber === 1 && _this.currentStepIndex === 2) {
                stepNumber -= 1;
              }
            }
            return moveStep();
          };
        })(this));
      } else {
        return moveStep();
      }
    };

    FieldprintService.prototype.findStepIndexByName = function(stepName) {
      return this.config[this.crop].steps.value[stepName]['order'];
    };

    FieldprintService.prototype.copy = function(id, fields) {
      return this.http.post("backend/grower/fieldprint/" + id + "/copy", {
        fields: fields
      });
    };

    FieldprintService.prototype.save = function(id) {
      var currentStepName, i, len, onSaveFn, ref;
      ref = this.onSaveTriggers;
      for (i = 0, len = ref.length; i < len; i++) {
        onSaveFn = ref[i];
        onSaveFn();
      }
      if (this.currentStepName) {
        currentStepName = this.currentStepName;
        this.http.post("backend/grower/fieldprint/" + id + "/step/" + currentStepName + "/saved");
        this.savedSteps.push(currentStepName);
      }
      return this.http.post("backend/grower/fieldprint/" + id + "/save", this.fpcResult.data);
    };

    FieldprintService.prototype.updateCompletenessFor = function(element, inputName) {
      return this.completenessElements[inputName] = element;
    };

    FieldprintService.prototype.calculateCompleteness = function() {
      if (!this.fpcResult.id) {
        return;
      }
      return this.http.post("backend/grower/fieldprint/" + this.fpcResult.id + "/completeness", {
        data: this.fpcResult.data
      }).then((function(_this) {
        return function(response) {
          var anyErrors, element, inputName, ref;
          _this.fpcResult.completeness = response.data;
          anyErrors = false;
          ref = _this.completenessElements;
          for (inputName in ref) {
            element = ref[inputName];
            if ((_this.fpcResult.completeness.inputs[inputName] != null) && _this.fpcResult.completeness.inputs[inputName]) {
              element.removeClass('missing');
            } else {
              element.addClass('missing');
              anyErrors = true;
            }
          }
          if (!anyErrors) {
            return _this.showIncompletenessMessage = false;
          }
        };
      })(this));
    };

    FieldprintService.prototype.irrigationValidationValues = function() {
      if (this.validationIrrigationValues[this.crop]) {
        return this.validationIrrigationValues[this.crop];
      } else {
        return this.validationIrrigationValues['default'];
      }
    };

    FieldprintService.prototype.calculatorSucceeded = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return fpcResult.dryland_status === 'success' && fpcResult.irrigated_status === 'success';
    };

    FieldprintService.prototype.calculatorFailed = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return fpcResult.dryland_status === 'failed' || fpcResult.irrigated_status === 'failed';
    };

    FieldprintService.prototype.calculatorPending = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return fpcResult.dryland_status === 'pending' || fpcResult.irrigated_status === 'pending';
    };

    FieldprintService.prototype.calculatorErrored = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return fpcResult.dryland_status.startsWith('error') || fpcResult.irrigated_status.startsWith('error');
    };

    FieldprintService.prototype.badSoils = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return fpcResult.dryland_status.indexOf('Missing param: slope_length') >= 0 || fpcResult.irrigated_status.indexOf('Missing param: slope_length') >= 0;
    };

    FieldprintService.prototype.badClimate = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return !this.badSoils() && (fpcResult.dryland_status.indexOf('No climate zones') >= 0 || fpcResult.irrigated_status.indexOf('No climate zones') >= 0);
    };

    FieldprintService.prototype.badPlantableAcres = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return !this.badClimate() && (fpcResult.dryland_status.indexOf('plantable_acres exceeds 10%') >= 0 || fpcResult.irrigated_status.indexOf('plantable_acres exceeds 10%') >= 0);
    };

    FieldprintService.prototype.badMyFarms = function(fpcResult) {
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      return !this.badPlantableAcres(fpcResult);
    };

    FieldprintService.prototype.badGeometry = function() {
      return this.fpcResult.dryland_status.indexOf('Invalid geometry passed to createGISObject') >= 0 || this.fpcResult.irrigated_status.indexOf('Invalid geometry passed to createGISObject') >= 0;
    };

    FieldprintService.prototype.hasCoverCropEvents = function() {
      var ref;
      return !!((ref = this.fpcResult.events['cover_crop']) != null ? ref.length : void 0);
    };

    FieldprintService.prototype.getManagementTechniquesDefaults = function() {
      return this.http.get('backend/grower/fieldprint/management-techniques-defaults', {
        params: {
          layer_ids: JSON.stringify(this.fpcResult.events['fertilizer'])
        }
      }).then((function(_this) {
        return function(response) {
          var inhibitor, key, ref;
          ref = response.data.inhibitors;
          for (key in ref) {
            inhibitor = ref[key];
            if (inhibitor === 'Urease' || inhibitor === 'Nitrification + Urease') {
              _this.fpcResult.data['nutrient_management_techniques'].push('Nutrient Application Form - Urease Inhibitors');
            }
            if (inhibitor === 'Nitrification' || inhibitor === 'Nitrification + Urease') {
              _this.fpcResult.data['nutrient_management_techniques'].push('Nutrient Application Form - Nitrification Inhibitors');
            }
          }
          if (response.data.slow_release) {
            _this.fpcResult.data['nutrient_management_techniques'].push('Nutrient Application Form - Slow or Time Release Nitrogen Fertilizers');
          }
          return _this.fpcResult.data['nutrient_management_techniques'] = _this.fpcResult.data['nutrient_management_techniques'].filter(function(c, index) {
            return _this.fpcResult.data['nutrient_management_techniques'].indexOf(c) === index;
          });
        };
      })(this));
    };

    FieldprintService.prototype.hasPBIUploadedConnection = function(year) {
      return this.http.get('backend/grower/pbi/has-uploaded-pbi-connection', {
        params: {
          year: year
        }
      });
    };

    FieldprintService.prototype.resetDropDown = function() {
      this.fpcResult.data['phosphorous_soil_test_level'] = null;
      return this.fpcResult.data['phosphorous_drawdown_strategies'] = [];
    };

    FieldprintService.prototype.resetDrawdown = function() {
      if (this.fpcResult.data['phosphorous_soil_test_level'] !== 'Excessive/Very High') {
        return this.fpcResult.data['phosphorous_drawdown_strategies'] = [];
      }
    };

    FieldprintService.prototype.downloadPdfs = function(fpcResult) {
      var url;
      if (fpcResult == null) {
        fpcResult = this.fpcResult;
      }
      url = new URL('/backend/grower/fieldprint/download-pdf', window.location.origin);
      url.searchParams.set('id', fpcResult.id);
      if (fpcResult.dryland_response) {
        url.searchParams.set('type', 'dryland');
        window.open(url.toString());
      }
      if (fpcResult.irrigated_response && fpcResult.data['irrigated']) {
        url.searchParams.set('type', 'irrigated');
        return window.open(url.toString());
      }
    };

    FieldprintService.prototype.goToFirstIncompleteStep = function(id, skipNutrientManagementStep) {
      var i, index, len, ref, step;
      if (skipNutrientManagementStep == null) {
        skipNutrientManagementStep = false;
      }
      ref = Object.keys(this.fpcResult.completeness.steps);
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        step = ref[index];
        if (!this.fpcResult.completeness.steps[step] || !this.fpcResult.saved_steps.includes(step)) {
          if (skipNutrientManagementStep && step === 'Nutrient Management Tool(s)') {
            this.gotoStep(0, id, false);
            return;
          }
          this.gotoStep(index, id, true, false, true);
          return;
        }
      }
      return this.gotoStep(0, id, false);
    };

    return FieldprintService;

  })(Service);

}).call(this);
